import { subscribe_path } from '@routes';
import {
  DEFAULT_ANNUAL_PRICE,
  DEFAULT_YOUNG_PROFESSIONAL_PRICE,
  DISCOUNTED_PRO_PRICE,
  MONTHLY_PRICE_39,
  NOW_ANNUAL_OFFER_CODE,
  NOW_MONTHLY_OFFER_CODE,
  NOW_PRO_OFFER_CODE,
  NOW_YP_OFFER_CODE,
} from '@src/constants';

export type planType = 'monthly' | 'annual' | 'pro' | 'yp';
export type titleType =
  | 'The Information Pro'
  | 'The Information Annual'
  | 'The Information Monthly'
  | 'Young Professionals';

interface GenerateCardPropArgs {
  planType: planType;
  hrefParams?: { [key: string]: string };
}

export interface Offer {
  benefits: string[];
  description?: string;
  href: string;
  length: string;
  originalPrice?: number;
  price: number;
  title: titleType;
}

export const generateCardProps = ({ planType, hrefParams = {} }: GenerateCardPropArgs): Offer => {
  let benefits: string[] = [];
  let description: string;
  let href: string;
  let length = 'Year';
  let price: number;
  let originalPrice: number;
  let title: titleType;

  switch (planType) {
    case 'monthly':
      href = subscribe_path({ offer: NOW_MONTHLY_OFFER_CODE, ...hrefParams });
      benefits = [
        'Access to reporting',
        'Access to Profiles, Directory and Forum',
        'No access to org charts',
        'Billed every four weeks',
      ];
      price = MONTHLY_PRICE_39;
      title = 'The Information Monthly';
      length = 'Month';

      break;
    case 'annual':
      href = subscribe_path({ offer: NOW_ANNUAL_OFFER_CODE, ...hrefParams });
      benefits = [
        "Read articles you won't find elsewhere",
        'Subscribe to our suite of newsletters',
        'Access to Profiles, Directory and Forum',
        'Read on the go with The Information app',
      ];
      price = DEFAULT_ANNUAL_PRICE;
      title = 'The Information Annual';

      break;
    case 'yp':
      href = subscribe_path({ offer: NOW_YP_OFFER_CODE, ...hrefParams });
      benefits = [
        'Available for those 30 and under',
        'Read articles you won’t find anywhere else',
        'Subscribe to our suite of newsletters',
        'Access to Profiles, Directory and Forum',
        'Receive two years of Annual access at our best price',
        'Read on the go with The Information app',
      ];
      price = DEFAULT_YOUNG_PROFESSIONAL_PRICE;
      originalPrice = DEFAULT_ANNUAL_PRICE;
      title = 'Young Professionals';
      description =
        'If you’re 30 or under, access all of our original journalism at our most competitive rate (44% off), for two years.';

      break;
    case 'pro':
      href = subscribe_path({ offer: NOW_PRO_OFFER_CODE, ...hrefParams });
      benefits = [
        'Our org chart library, updated and added to monthly',
        'Exclusive surveys and proprietary databases',
        'All of our award-winning journalism',
        'An exclusive newsletter for Pro subscribers',
      ];
      price = DISCOUNTED_PRO_PRICE;
      title = 'The Information Pro';

      break;
  }

  return {
    benefits,
    description,
    href,
    length,
    originalPrice,
    price,
    title,
  };
};
